import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
      <p className="text-7xl font-black text-background-200 font-heading md:text-9xl">404</p>
      <h1 className="mt-4 text-xl font-bold text-foreground-950 font-heading md:text-2xl">
        页面走丢了
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        你访问的页面不存在或已被移除，不妨回到首页继续逛逛
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-accent-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
        >
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="whitespace-nowrap rounded-md bg-background-100 px-6 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:bg-background-200"
        >
          浏览电影
        </Link>
      </div>
    </div>
  );
}